/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the job context component.
 */
export const JOB_CONTEXTS_DATA_IDS = {
  contextNameButton: `Button: Job context name`,
  createButton: `Button: Create job context`,
  searchBar: `Search filter: Search job contexts`,
};
